import { render, staticRenderFns } from "./LegendLayersList.vue?vue&type=template&id=28dff930&"
import script from "./LegendLayersList.vue?vue&type=script&lang=js&"
export * from "./LegendLayersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports